import { createSlice } from '@reduxjs/toolkit';

interface Config {
  options: Record<string, unknown>;
}

// Creating a Redux slice for managing analytics _state
const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: {}, // Initial state is empty
  reducers: {
    // Reducer for sending the event of selecting an item
    trackPageView: () => {},
    // Reducer for tracking a page view
    trackSearchCruise: (_state, __action) => {},
    trackSearchExcursionEvent: (__state, _action) => {},
    trackPaymentInfo: () => {},
    trackPurchase: (_state, _action) => {},
    trackHoldOptionEvent: () => {},
    trackPurchaseFailed: (_state, _action) => {},
    trackPaymentFailed: (_state, _action) => {},
    trackViewItemList: (_state, _action) => {},
    trackSelectItem: (_state) => {},
    trackViewItem: (_state) => {},
    trackAddToWishlist: (_state, _action) => {},
    trackCruiseShare: (_state, _action) => {},
    trackAddToCart: (_state, _action) => {
      const payload = _action?.payload || {}; // Fallback to an empty object if no payload is provided
      const { date, data } = payload;
    },
    trackBeginCheckout: () => {},
    trackCheckoutProgressGuestAndCabin: () => {},
    trackCheckoutCabinTypeSelection: () => {},
    trackCheckoutCabinPreferences: () => {},
    trackCheckoutCabinTypeDetails: () => {},
    trackCheckoutCabinLocation: () => {},
    trackViewCart: () => {},
    trackUpgradeOffer: () => {},
    trackExtraServices: (_state, _action) => {},
    trackExtraServicesList: (_state, _action) => {},
    trackPassengersDetails: () => {},
    trackInsuranceInfo: (state) => state,
  },
});

// Exporting the _actions created by the slice
export const {
  trackSelectItem,
  trackPageView,
  trackSearchCruise,
  trackSearchExcursionEvent,
  trackPaymentInfo,
  trackPurchase,
  trackHoldOptionEvent,
  trackPurchaseFailed,
  trackPaymentFailed,
  trackViewItemList,
  trackAddToWishlist,
  trackCruiseShare,
  trackAddToCart,
  trackViewItem,
  trackBeginCheckout,
  trackCheckoutProgressGuestAndCabin,
  trackCheckoutCabinTypeSelection,
  trackCheckoutCabinPreferences,
  trackCheckoutCabinTypeDetails,
  trackCheckoutCabinLocation,
  trackViewCart,
  trackUpgradeOffer,
  trackExtraServices,
  trackExtraServicesList,
  trackPassengersDetails,
  trackInsuranceInfo,
} = analyticsSlice.actions;
// Exporting the reducer
export default analyticsSlice.reducer;
